import React from 'react';
const MasterModalContent = (props) => {
  return <>{React.cloneElement(props.children, { node: props.node })}</>;
};
export default MasterModalContent;
